<template>
  <div class="p-6">

    <!-- Header Card -->
        <PageHeader icon="far fa-calendar-alt">
      <template #title>
        Daftar Perjanjian {{ currentDoctor.name }}
      </template>
      <template #subtitle>
        Kelola dan tinjau jadwal pendaftaran serta perjanjian dokter
      </template>
    </PageHeader>

    <div class="row align-items-start">

      <div class="col-xl-9">
        <Card>
          <template v-slot:body>
            <b-tabs
              class="mt-n3"
              content-class="mt-3">
              <b-tab
                title="Kalender"
                active>
                <Calendar
                  :isMyAppointment="true"
                  :currentDoctor="currentDoctor" />
              </b-tab>
              <b-tab title="Perjanjian">
                <Table
                  :items="items"
                  :itemExcel="itemExcel"
                  :itemPopUp="itemPopUp"
                  :fields="fields"
                  :isMyAppointment="true"
                  :perPage="perPage"
                  :currentPage="currentPage"
                  :totalRows="totalRows"
                  :tabFiled="tabFiled"
                  @appointmentOnStatusChange="pagination"
                  @filter="generalFilter"
                  @filterByPatient="generalFilter"
                  @pageOnClick="pageOnClick"
                  @btnExportOnClick="btnExportOnClick" />
              </b-tab>
            </b-tabs>
          </template>
        </Card>
      </div>

      <div class="col-xl-3">
        <Card title="Dokter" card-class="doctor-profile-card">
          <template v-slot:body>
            <div class="doctor-profile">
              <div class="doctor-profile__identity">
                <div class="doctor-profile__photo-wrap">
                  <img
                    class="doctor-profile__photo"
                    :src="doctorPhoto"
                    :alt="`Foto ${doctorName}`"
                    @error="useDefaultDoctorPhoto"
                  >
                  <span class="doctor-profile__status" title="Dokter aktif"></span>
                </div>

                <div class="doctor-profile__summary">
                  <strong>{{ doctorName }}</strong>
                  <span>{{ doctorPolyclinic }}</span>
                  <button
                    v-if="currentDoctor.id"
                    type="button"
                    class="doctor-profile__info"
                    @click="openDoctorDetail"
                  >
                    Info
                  </button>
                </div>
              </div>

              <dl class="doctor-profile__contacts">
                <div>
                  <dt>Email</dt>
                  <dd>{{ currentDoctor.email || '-' }}</dd>
                </div>
                <div>
                  <dt>Telepon</dt>
                  <dd>{{ currentDoctor.phone || '-' }}</dd>
                </div>
              </dl>
            </div>
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import Table from '@/component/appointments/Table.vue'
import Calendar from '@/component/doctors/Calendar.vue'
import module from '@/core/modules/CrudModule.js'
import { mapGetters } from 'vuex'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import moment from 'moment'

export default {

  components: {
    Card,
    Table,
    Calendar
  },

  data() {
    return {
      filter: {
        appointment_status_id: '',
        start_date: '',
        end_date: '',
        patient_name: '',
        start_date: moment().startOf('day').format('YYYY-MM-DD'),
        end_date: moment().endOf('day').format('YYYY-MM-DD'),
      },
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "display_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "time",
          label: "Waktu",
          sortable: true,
        },
        {
          key: "action_type_name",
          label: "Jenis Tindakan",
          sortable: true,
        },
        {
          key: "appointment_status_name",
          label: "Status",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      items: [],
      itemExcel: [],
      itemPopUp: [],
      tabFiled: 0,
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&appointment_status_id=${this.filter.appointment_status_id}&patient_name=${this.filter.patient_name}&doctor_id=${this.currentDoctor.id}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
      let response = await module.paginate('appointments', `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.items = response.data
      this.totalRows = pagination.total
    },

    async getExport() {
      const excelRoute = 'appointment-excel'
      const popUpRoute = 'appointment-no-paginations'
      let filterParams = `&appointment_status_id=${this.filter.appointment_status_id}&patient_name=${this.filter.patient_name}&doctor_id=${this.currentDoctor.id}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
      let responseExcel = await module.get(excelRoute, `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let responsePopUp = await module.get(popUpRoute, `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      this.itemExcel = responseExcel
      this.itemPopUp = responsePopUp
    },

    setFilter(sent) {
      for (const key in this.filter) {
        this.filter[key] = sent[key]
      }
      if (
        this.filter.patient_name != '' ||
        this.filter.appointment_status_id != '' ||
        this.filter.start_date != '' ||
        this.filter.end_date != ''
      )
        this.currentPage = 1
    },

    async generalFilter(sent) {
      this.setFilter(sent)
      this.pagination()
    },

    async btnExportOnClick(filter) {
      this.setFilter(filter)
      await this.getExport()
    },

    openDoctorDetail() {
      this.$router.push({ path: `/doctor/detail/${this.currentDoctor.id}` })
    },

    useDefaultDoctorPhoto(event) {
      if (event.target.src.indexOf('doctor-default.svg') === -1)
        event.target.src = '/media/users/doctor-default.svg'
    }

  },

  computed: {
    ...mapGetters({
      currentDoctor: 'currentUserPersonalInfo'
    }),

    doctorName() {
      return this.currentDoctor.name || 'Dokter'
    },

    doctorPolyclinic() {
      return this.currentDoctor.polyclinic_name || 'Poliklinik belum ditentukan'
    },

    doctorPhoto() {
      return this.currentDoctor.photo || '/media/users/doctor-default.svg'
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dokter", route: "" },
      { title: "Perjanjian Saya" }
    ])
    this.pagination()
  }

}
</script>

<style lang="scss" scoped>
.doctor-profile-card {
  overflow: hidden;
}

.doctor-profile {
  min-height: 300px;
}

.doctor-profile__identity {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.doctor-profile__photo-wrap {
  position: relative;
  width: 92px;
  height: 92px;
  flex: 0 0 92px;
}

.doctor-profile__photo {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  border-radius: 50%;
  background: #eef8f7;
  border: 4px solid #eef8f7;
}

.doctor-profile__status {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #20b486;
  border: 3px solid #fff;
  box-sizing: content-box;
}

.doctor-profile__summary {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 5px;
}

.doctor-profile__summary strong {
  color: #172b4d;
  font-size: 1.2rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.doctor-profile__summary span {
  margin-top: 3px;
  color: #7b8798;
}

.doctor-profile__info {
  margin-top: 17px;
  padding: 9px 20px;
  color: #fff;
  font-weight: 700;
  background: linear-gradient(135deg, #145a91, #159792);
  border: 0;
  border-radius: 10px;
  box-shadow: 0 8px 18px rgba(20, 90, 145, 0.2);
}

.doctor-profile__info:hover,
.doctor-profile__info:focus-visible {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(20, 90, 145, 0.28);
}

.doctor-profile__contacts {
  margin: 34px 0 0;
}

.doctor-profile__contacts > div {
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr);
  gap: 8px;
  margin-bottom: 14px;
}

.doctor-profile__contacts dt,
.doctor-profile__contacts dd {
  margin: 0;
}

.doctor-profile__contacts dt {
  color: #172b4d;
  font-weight: 700;
}

.doctor-profile__contacts dd {
  color: #7b8798;
  overflow-wrap: anywhere;
}

@media (max-width: 1199.98px) {
  .doctor-profile-card {
    margin-top: 8px;
  }

  .doctor-profile {
    min-height: 0;
  }
}
</style>
